export default __webpack_public_path__ + "static/media/step-1.7975394a.7975394a.jpg";